var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: "",
        visible: _vm.visible,
        width: "70%",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "page-title",
          attrs: { slot: "title", name: "title" },
          slot: "title",
        },
        [
          _c(
            "div",
            {
              staticClass: "line",
              class: [_vm.markerInfo.lineName ? "margin-right-10" : ""],
            },
            [_vm._v("\n      " + _vm._s(_vm.markerInfo.lineName) + "\n    ")]
          ),
          _vm.markerInfo.stationName
            ? _c("div", [_vm._v(_vm._s(_vm.markerInfo.stationName) + "-")])
            : _vm._e(),
          _c("div", [
            _vm._v(
              _vm._s(_vm.markerInfo.name) +
                "（" +
                _vm._s(_vm.markerInfo.longitude) +
                ", " +
                _vm._s(_vm.markerInfo.latitude) +
                "） "
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "map-box" }, [
        _c("div", { staticClass: "amapContainer" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }